import styled from 'styled-components'

export const S_UploadResults = styled.div`
  min-width: 720px;

  h1 {
    margin-bottom: 20px;
  }
`

export const S_SucessfullUploads = styled.div`
  background: rgb(244, 255, 244);
  border: 2px solid rgb(153, 190, 153);
  padding: 10px 20px;
  margin-bottom: 20px;
`

export const S_UploadErrorsContainer = styled.div`
  background: rgb(255, 244, 244);
  border: 2px solid rgb(255, 153, 153);
  padding: 10px 20px;
  margin-bottom: 20px;
`

export const S_ErrorsTitle = styled.h3`
  margin-bottom: 5px;
`

export const S_ErrorRow = styled.div``

export const S_ErrorRowNumber = styled.span``

export const S_ErrorColumns = styled.div`
  padding: 5px 20px;
`

export const S_ErrorColumnItem = styled.div``

export const S_ErrorColumnName = styled.span`
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: rgb(255, 193, 193);
  padding: 2px 5px 2px 10px;
  float: left;
  width: 140px;
`

export const S_ErrorColumnDescription = styled.span`
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: rgb(255, 210, 210);
  padding: 2px 10px 2px 150px;
  display: block;
`

export const S_UploadWarningsContainer = styled.div`
  background: #ffffee;
  border: 2px solid #ffcc98;
  padding: 10px 20px;
`

export const S_UploadWarningsList = styled.div``

export const S_WarningsTitle = styled.h3`
  margin-bottom: 5px;
`

export const S_WarningRow = styled.div``

export const S_WarningRowNumber = styled.span``

export const S_WarningColumns = styled.div`
  padding: 5px 20px;
`

export const S_WarningColumnName = styled.span`
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: #ffeeaa;
  padding: 2px 5px 2px 10px;
  float: left;
  width: 140px;
`

export const S_WarningColumnDescription = styled.span`
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: #ffffbb;
  padding: 2px 10px 2px 150px;
  display: block;
`

export const S_WarningColumnItem = styled.div``
